import { Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-filter-common',
    template:``,
    styleUrls:['./list-filter.common.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ListFilterCommonComponent{}